import { STORAGE_FOLDERS, uploadImage } from '../../../firebase';
import customToast from '@/new-components/CustomNotification';
import isEmpty from 'lodash/isEmpty';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  updatePatient:
    (payload, callbackSuccess) =>
    async ({ Api, toastr }) => {
      let corporatePlans = [];

      if (!isEmpty(payload.corporatePlans)) {
        corporatePlans = await Promise.all(
          payload.corporatePlans.map(async (file) => {
            if (
              file.frontPhoto?.constructor === File &&
              file.backPhoto?.constructor === File
            ) {
              let fontUrl = await uploadImage(
                file.frontPhoto,
                undefined,
                STORAGE_FOLDERS.corporatePlanPhoto
              );
              let backUrl = await uploadImage(
                file.backPhoto,
                undefined,
                STORAGE_FOLDERS.corporatePlanPhoto
              );

              return { ...file, frontPhoto: fontUrl, backPhoto: backUrl };
            } else {
              // Front Photo
              if (file.frontPhoto?.constructor === File) {
                let url = await uploadImage(
                  file.frontPhoto,
                  undefined,
                  STORAGE_FOLDERS.corporatePlanPhoto
                );
                return { ...file, frontPhoto: url };
              }
              // Back Photo
              else if (file.backPhoto?.constructor === File) {
                let url = await uploadImage(
                  file.backPhoto,
                  undefined,
                  STORAGE_FOLDERS.corporatePlanPhoto
                );
                return { ...file, backPhoto: url };
              } else return file;
            }
          })
        );
      }

      // Callers are admins editing someone else's record, so the patient is
      // addressed by id - `patients/me` would have written to the admin's own profile
      const { status } = await Api.put(`patients/${payload.userId}`, {
        ...payload,
        corporatePlans,
      });
      if (status === 200) {
        callbackSuccess();
        return customToast('success', 'Your profile is updated successfully');
      }
    },
  getPatientList:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      const pagingData = paging || getState().patient.paging;
      const { pageIndex, pageSize } = pagingData;

      const { result, status } = await Api.post(`patients/filter`, {
        pageIndex,
        pageSize,
        search,
        ...sortOption,
        ...filterOption,
      });

      status === 200 && patientDispatcher.getPatientListSuccess(result);
    },
  getPatientListBySearch:
    (search, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.post(`patients/filter`, {
        search,
      });
      status === 200 && callback(result);
    },
  getPatientListSuccess: (payload) => payload,
  approvePatient:
    (payload, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.post(`patients/approvals`, payload);
      if (status === 200) {
        patientDispatcher.approvePatientSuccess(payload);
        callbackSuccess(payload.userId);
        customToast('success', 'Success');
        return;
      }
    },
  approvePatientSuccess: (payload) => payload,
  deletePatient:
    (userId, callbackSuccess) =>
    async ({ Api, customToast }) => {
      let { status } = await Api.delete(`users/${userId}`);
      if (status === 200) {
        customToast('success', 'Deleted successfully');
        callbackSuccess();
      }
    },

  deletePatientUser:
    (userId, callbackSuccess) =>
    async ({ Api, customToast }) => {
      let { status } = await Api.delete(`patients/${userId}`);
      if (status === 200) {
        customToast('success', 'Deleted successfully');
        callbackSuccess();
      }
    },
  inActiveOrActivePatient:
    (payload, onSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.post(`patients/activations`, payload);
      if (status === 200) {
        patientDispatcher.inActiveOrActivePatientSuccess(payload);
        onSuccess ? onSuccess() : customToast('success', 'Success');
      }
    },
  inActiveOrActivePatientSuccess: (payload) => payload,
  resetData: () => ({}),
  createDependentProfile:
    (data, onSuccess, onError) =>
    async ({ Api }) => {
      const { status } = await Api.post(`family-groups`, data);
      if (status === 200) {
        onSuccess && onSuccess();
      } else {
        onError && onError();
      }
    },

  deleteDependentProfile:
    (userId, callbackSuccess) =>
    async ({ Api, customToast }) => {
      let { status } = await Api.delete(`family-groups/${userId}`);
      if (status === 200) {
        customToast('success', 'Deleted successfully');
        callbackSuccess();
      }
    },

  getUserAddress:
    (userId, callbackSuccess) =>
    async ({ Api }) => {
      let { status, result } = await Api.get(
        `user-addresses/${userId}/all-by-user`
      );
      if (status === 200) {
        callbackSuccess(result);
      }
    },

  createUserAddress:
    (data, onSuccess, onError) =>
    async ({ Api }) => {
      const { status } = await Api.post(`user-addresses`, data);
      if (status === 200) {
        onSuccess && onSuccess();
      } else {
        onError && onError();
      }
    },

  editUserAddress:
    (data, onSuccess, onError) =>
    async ({ Api }) => {
      const { status } = await Api.put(`user-addresses/${data.id}`, {
        userId: data.userId,
        address: data.address,
        unitNumber: data.unitNumber,
        postalCode: data.postalCode,
        isDefault: data.isDefault,
        longitude: data.longitude,
        latitude: data.latitude,
        floor: data.floor,
        ignoredUnitNumber: data.ignoredUnitNumber,
      });
      if (status === 200) {
        onSuccess && onSuccess();
      } else {
        onError && onError();
      }
    },
};

const patientDispatcher = synthesize('patient', mapDispatchToAC);
export default patientDispatcher;
